import {
  GoogleMap,
  Marker,
  Polyline,
  useJsApiLoader,
} from '@react-google-maps/api';
import React,{ useEffect, useState } from 'react';
import {
  getLocationReferences,
} from '../../../helpers/mapsHelper';

import clientHouse from '../../../img/icons/marker-client.png';
import werehouse from '../../../img/icons/marker-warehouse.png';
import shipMark from '../../../img/icons/ship-icon.png';
import Modal from './ModalConfirm';

function Maps ({ dataPoItem }) {

    const GoogleMapContainer = () => {
      const [currentLocation, setCurrentLocation] = useState(null);
      const [coordinates, setCoordinates] = useState([]);
      const [locationReference, setLocationReferences] = useState([]);

      const { isLoaded, loadError } = useJsApiLoader({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY_SINERGIA,
        libraries: ['places'],
        mapIds: ['87412a572f003751'],
      });

      const defaultCenter = {
        lat: 0,
        lng: 0,
      };

      useEffect(() => {
        if (
          dataPoItem.current_vessel_latitude &&
          dataPoItem.current_vessel_longitude
        ) {
          setCurrentLocation({
            lat: Number(dataPoItem.current_vessel_latitude),
            lng: Number(dataPoItem.current_vessel_longitude),
          });
        }
      }, []);

      useEffect(() => {
        const fetchLocationReferences = async () => {
          try {
            const { locationReferences } = await getLocationReferences();
            setLocationReferences(locationReferences || []);
          } catch (err) {
            console.error('Erro ao buscar localizações:', err);
          }
        };

        fetchLocationReferences();
      }, []);

      useEffect(() => {
        if (!isLoaded || !dataPoItem.origin || !dataPoItem.destination) return;
        const destinationCountry =
          locationReference.find(loc =>
            loc.description.includes(dataPoItem.destination)
          ) || '';
        const geocoder = new window.google.maps.Geocoder();
        const originQuery = `${dataPoItem.origin}, ${dataPoItem.country_of_origin}`;
        const destinationQuery = `${destinationCountry.description || ''}`;
        const locations = [originQuery, destinationQuery];

        Promise.all(
          locations.map(
            location =>
              new Promise((resolve, reject) => {
                geocoder.geocode({ address: location }, (results, status) => {
                  if (status === 'OK' && results[0]) {
                    const { lat, lng } = results[0].geometry.location;
                    resolve({ lat: lat(), lng: lng() });
                  } else {
                    reject(`Geocoding failed for ${location}: ${status}`);
                  }
                });
              })
          )
        )
          .then(results => setCoordinates(results))
          .catch(err => console.error(err));

      }, [isLoaded, dataPoItem, locationReference]);

      if (loadError) {
        return <div>Erro ao carregar o Google Maps</div>;
      }

      if (!isLoaded) {
        return <div>Carregando mapa...</div>;
      }

      return (
        <GoogleMap
          mapContainerStyle={{ width: '100%', height: '400px' }}
          center={coordinates[0] || defaultCenter}
          zoom={3}
          options={{ mapId: '87412a572f003751' }}
        >
          {coordinates.map((coord, index) => (
            <Marker
              key={index}
              position={coord}
              label={index === 0 ? '' : ''}
              icon={{
                url: index === 0 ? clientHouse : werehouse,
                scaledSize: new window.google.maps.Size(70, 55),
              }}
            />
          ))}

          {currentLocation && !dataPoItem.ata_date && (
            <Marker
              key={'current-location'}
              position={currentLocation}
              label=""
              icon={{
                url: shipMark,
                scaledSize: new window.google.maps.Size(60, 50),
              }}
            />
          )}

          {coordinates.length === 2 && (
            <Polyline
              path={coordinates}
              options={{
                strokeColor: '#FF0000',
                strokeOpacity: 0.7,
                strokeWeight: 2,
              }}
            />
          )}
        </GoogleMap>
      );
    };

    const isShipsGo =
      dataPoItem && dataPoItem?.shipment_tracking_code && !dataPoItem.ata_date;

    return (
      <>
        <div className="live-map-container" >
          <Modal data={dataPoItem}/>

          {isShipsGo &&  (
            <div className="iframe-wrapper">
              <iframe
                src={`https://shipsgo.com/iframe/where-is-my-container/${dataPoItem?.container_code}?tags=hide-search-box`}
                id="IframeShipsgoLiveMap"
                className="live-map-iframe"
                title="Shipsgo Live Map"
                width="100%"
                height={'550px'}
              ></iframe>
            </div>
          )}

          {!isShipsGo && <GoogleMapContainer />}
        </div>
      </>
    );
}


export default Maps;
